'use es6';

import { CustomObjectTypeIdRegex } from '../../../filterQueryFormat/ObjectTypeId';
import { REFERENCE_RECORD } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { toDSFieldRecord } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import PortalIdParser from 'PortalIdParser';
import createDSAdapter from './createDSAdapter';
import formatProperties from 'reference-resolvers/formatters/formatProperties';
import http from 'hub-http/clients/apiClient';
export function makeCustomObjectPropertiesAdapter() {
  const cachedPropertyGroups = {};
  function isAssetFamilySupported(assetFamily) {
    return CustomObjectTypeIdRegex.test(assetFamily);
  }
  function getFetcherFromProps() {
    return http.get;
  }
  function fetch(httpClient, __, assetFamily) {
    if (cachedPropertyGroups[assetFamily]) {
      return Promise.resolve(cachedPropertyGroups[assetFamily]);
    }
    const options = {
      query: {
        portalId: PortalIdParser.get(),
        includeProperties: true,
        includeFieldLevelPermission: true
      }
    };
    return httpClient(`properties/v4/groups/${assetFamily}`, options).then(response => {
      const result = response.results;
      cachedPropertyGroups[assetFamily] = result;
      return result;
    });
  }
  function updater(result, prevData, assetFamily) {
    const formattedProperties = formatProperties(result);
    return toDSFieldRecord(formattedProperties, assetFamily, REFERENCE_RECORD);
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
}
const customObjectPropertiesAdapter = makeCustomObjectPropertiesAdapter();
export default customObjectPropertiesAdapter;